import React, { FC } from "react";
import { Span } from "../../../Text/Text";
import InfoTooltip from "../../../InfoTooltip/InfoTooltip";
import { TooltipPlaceE } from "../../../../models/enums";
import { useAppSelector } from "../../../../store/hooks";
import { selectDirection } from "../../../../store/selectors/appSelectors";

import styles from "../../form.module.scss";

/**
 * Label component for custom form component
 * */

type LabelPropTypes = React.LabelHTMLAttributes<HTMLLabelElement> & {
  name: string;
  label: string;
  hintText?: string;
  place?: TooltipPlaceE;
  addAction?: () => void;
  children?: any;
};

const Label: FC<LabelPropTypes> = ({
  name,
  label,
  hintText,
  children,
  place = TooltipPlaceE.TOP,  
  addAction,
  ...props
}) => {
  const direction = useAppSelector(selectDirection);
  return (
    <label htmlFor={name} {...props}>
      <div className={styles.label} style={{ direction }}>
        {label && <Span className={styles.labelText}>{label}</Span>}
        {hintText && <InfoTooltip text={hintText} place={place} addAction={addAction} />}
      </div>
      {children}
    </label>
  );
};

export default Label;
